import {
  Form,
  SubmitButton,
} from '@codev/helix-react';
import React from 'react';
import {
  Button,
  ButtonToolbar,
} from 'react-bootstrap';
import PropTypes from 'prop-types';

const FormPanel = ({
  action,
  cancelText = 'Cancel',
  cancelIndex,
  className,
  children,
  onCancel,
  showCancelButton,
  showCancelButtonOnLeft,
  submitText = 'Save',
  submitIndex,
  submitting,
  ...rest
}) => (
  <Form
    action={action}
    className={className}
    method="post"
    {...rest}
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '20px',
      minHeight: '268px',
      width: '100%',
      ...rest.style,
    }}
  >

    {children}

    <ButtonToolbar
      style={{
        float: 'right',
        marginBottom: '15px',
        marginRight: '30px',
        marginTop: 'auto',
      }}
    >
      <SubmitButton
        style={{float: 'right'}}
        tabIndex={submitIndex}
        {...(submitting === undefined ? {} : {isSubmitting: submitting})}
      >
        {submitText}
      </SubmitButton>
      {
        showCancelButton &&
        <Button
          bsStyle={showCancelButtonOnLeft ? 'link' : 'default'}
          onClick={onCancel}
          style={!showCancelButtonOnLeft
            ? {float: 'right'}
            : {marginLeft: '50px'}
          }
          tabIndex={cancelIndex}
        >
          {cancelText}
        </Button>
      }
    </ButtonToolbar>
  </Form>
);

FormPanel.propTypes = {
  action: PropTypes.func,
  cancelIndex: PropTypes.number,
  cancelText: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onCancel: PropTypes.func,
  showCancelButton: PropTypes.bool,
  showCancelButtonOnLeft: PropTypes.bool,
  submitIndex: PropTypes.number,
  submitText: PropTypes.string,
  submitting: PropTypes.bool,
};

export default FormPanel;